import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { useState, type ReactNode } from "react";

import { useTokenGetter } from "./auth";
import { trpc } from "./trpc";

// Same-origin in the browser (Vite proxies /trpc to the Worker in dev;
// in production the Pages app talks to the deployed Worker via VITE_API_URL).
const API_BASE = import.meta.env.VITE_API_URL ?? "";

export function TrpcProvider({ children }: { children: ReactNode }) {
  const getToken = useTokenGetter();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 30_000, refetchOnWindowFocus: false },
        },
      }),
  );
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: `${API_BASE}/trpc`,
          async headers() {
            const token = await getToken();
            return token ? { Authorization: `Bearer ${token}` } : {};
          },
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
